import React from 'react';

function SeparatorComponent() {
  return (
    <hr
      style={{ border: 'none', borderTop: '2px solid #000', margin: '1.5em 0' }}
    />
  );
}

export default SeparatorComponent;
